<template>
  <div>
    <a-select
      :class="class"
      class="w100"
      :value="value"
      allow-clear
      show-search
      :multiple="false"
      :placeholder="placeholder"
      option-filter-prop="title"
      @change="onChange"
      @clear="onClear"
      @search="onSearch"
    >
      <a-select-option
        v-for="item in data?.records"
        :key="item.id"
        :value="item.id"
        :title="item.name"
      >
        <span v-if="item.name.indexOf(OverVal) > -1 && OverVal != ''">
          {{ item.name.substr(0, item.name.indexOf(OverVal))
          }}<span style="color: #f59a23 !important">{{ OverVal }}</span
          >{{ item.name.substr(item.name.indexOf(OverVal) + OverVal.length) }}
        </span>
        <span v-else> {{ item.name }} </span>
      </a-select-option>
      <template #dropdownRender="{ menuNode: menu }" v-if="addUnit">
        <v-nodes :vnodes="menu" />
        <a-divider style="margin: 4px 0" id="divider" />
        <div
          class="add-text"
          style="padding: 4px 12px; cursor: pointer"
          @mousedown="(e) => e.preventDefault()"
          @click="addItem"
        >
          <plus-outlined />
          新建结算单位
          <span v-if="showOverVal" style="color: #317efd">“{{ OverVal }}”</span>
        </div>
      </template>
    </a-select>
  </div>
</template>

<script lang="ts">
import { PlusOutlined } from "@ant-design/icons-vue";
import { defineComponent, onMounted, reactive, ref, toRefs } from "vue";
import { UnitService } from "@/views/material/unit/unit.service";
import { notifyEmitter } from "@/utils/emitter";

/**
 * 结算单位选择器
 *
 * 使用方式:
 * <unit-select v-model:value="formRef.unitId"></unit-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "UnitSelect",
  props: {
    value: { type: String, default: undefined },
    class: { type: String, default: "append-to-parentnode" },
    placeholder: { type: String, default: "请选择" },
    addUnit: { type: Boolean, default: false },
    defaultActiveFirstOption: { type: Boolean, default: false },
    firstActiveValue: { type: String, default: undefined },
  },
  components: {
    PlusOutlined,
    VNodes: (_, { attrs }) => {
      return attrs.vnodes;
    },
  },
  emits: ["update:value", "change", "visible"],
  setup(props, { attrs, slots, emit }) {
    const state = reactive({
      showOverVal: false,
      OverVal: "",
    });
    const { data, run, loading } = UnitService.useSimpleListApi();

    const onChange = (id, option, options) => {
      emit("update:value", id);
      emit("change", id);
    };

    const onClear = () => {
      emit("update:value", undefined);
      emit("change", undefined);
    };
    notifyEmitter.on("addUnit", async (e) => {
      if (Boolean(e)) {
        await run();
        notifyEmitter.emit("unitIdTrue", "true");
      }
    });
    const onSearch = (ele) => {
      let tmp: any = [];

      (data?.value as any).records.forEach((e) => {
        if (e.name.includes(ele)) {
          tmp = ["true", ...tmp];
        } else {
        }
      });
      state.OverVal = ele;

      if (tmp.length <= 0) {
        state.showOverVal = true;
      } else {
        state.showOverVal = false;
      }
    };

    const addItem = () => {
      if (!state.showOverVal) {
        state.OverVal = "";
      }
      notifyEmitter.emit("showAddUnit", state.OverVal);
    };

    onMounted(async () => {
      await run();
    });
    return {
      ...toRefs(state),
      data,
      loading,
      onChange,
      onClear,
      addItem,
      onSearch,
    };
  },
});
</script>
<style lang="less" scoped>
/deep/ .add-text {
  color: #505050 !important;
}
</style>
